import { Slot } from "./types";

export const splitTwoWeekByMonth = (days: Date[]) => {
  const first = [days[0]];
  let second: Date[] = [];
  for (let i = 1; i < days.length; i++) {
    if (days[i].getMonth() !== first[first.length - 1].getMonth()) {
      second = days.slice(i);
      break;
    } else {
      first.push(days[i]);
    }
  }
  return [first, second];
};

export const getAvailableDatesFromSlots = (slots: Slot[]) => {
  if (slots) {
    const available: Date[] = [];

    for (let i = 0; i < slots.length; i++) {
      const slotDate = new Date(slots[i].visitTimeISO);

      if (
        !available.find((ad) => {
          return (
            ad.getDate() === slotDate.getDate() &&
            ad.getMonth() === slotDate.getMonth()
          );
        })
      ) {
        available.push(slotDate);
      }
    }

    return available;
  }
};

export const splitDaysByWeeks = (days: Date[], firstDay: number) => {
  const firstDayInDays = days[0].getDay();
  const weeks: Array<Array<Date | null>> = [];
  const diff =
    firstDayInDays >= firstDay
      ? firstDayInDays - firstDay
      : 7 - firstDay + firstDayInDays;

  let curr = 0;
  for (let w = 0; w < 3; w++) {
    let week: Array<Date | null> = [];
    for (let i = 0; i < 7; i++) {
      // добавляем null в начале 1 недели или в конце недели
      if ((w === 0 && i < diff) || curr >= days.length) {
        week.push(null);
      } else {
        week.push(days[curr]);
        curr++;
      }
    }
    //не добавляем полностью путую неделю
    if (week.some((d) => d != null)) weeks.push(week);
  }

  return weeks;
};

export const generateTwoWeeks = (date: Date) => {
  let dates = [];
  for (let i = 0; i < 14; i++) {
    date.setTime(date.getTime() + 1000 * 60 * 60 * 24);
    dates.push(new Date(date.getTime()));
  }

  return dates;
};
